var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImmigration = function SvgImmigration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.433 31.667 2.8-2.367c.417-.35 1.117-.35 1.55 0l2.784 2.367c.65.333 1.45 0 1.683-.7l.534-1.6c.133-.384 0-.95-.284-1.234l-2.733-2.75c-.2-.2-.35-.583-.35-.85V21.45c0-.7.516-1.033 1.166-.767l5.584 2.4c.916.4 1.683-.1 1.683-1.1v-1.55c0-.8-.6-1.733-1.35-2.05l-6.567-2.833c-.283-.117-.5-.467-.5-.767v-3.45c0-1.133-.833-2.466-1.833-2.983a1.271 1.271 0 0 0-1.15 0c-1.017.5-1.833 1.85-1.833 2.983v3.45c0 .3-.233.65-.5.767l-6.567 2.833c-.733.317-1.35 1.25-1.35 2.05v1.55c0 1 .75 1.5 1.684 1.1l5.583-2.4c.633-.283 1.167.067 1.167.767v3.083c0 .284-.167.667-.35.85L14.5 28.117c-.283.283-.416.85-.283 1.233l.533 1.6c.233.717 1.017 1.05 1.683.717Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 36.667h10c8.334 0 11.667-3.334 11.667-11.667V15c0-8.333-3.334-11.666-11.667-11.666H15C6.667 3.334 3.334 6.667 3.334 15v10c0 8.334 3.333 11.667 11.666 11.667Z"
  })));
};
export default SvgImmigration;